/* unplugin-vue-components disabled */import script from "./common_foot.vue?vue&type=script&setup=true&lang=js"
export * from "./common_foot.vue?vue&type=script&setup=true&lang=js"

import "./common_foot.vue?vue&type=style&index=0&id=0b38e692&lang=css"

const __exports__ = script;

export default __exports__